import * as React from 'react';

import { ISVGProps } from './SVG';

export const RecorderSVG = ({ width, height, title, fill, secondaryFill }: ISVGProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 38.8 44.79">
    <title>{title}</title>
    <path
      className="primary"
      d="M28.62,19.44a10.59,10.59,0,1,0-14.68-3,10.21,10.21,0,0,0,3,3,20.83,20.83,0,0,0-6,4.65,12.19,12.19,0,0,1,9.68,14.53H37.11a1.7,1.7,0,0,0,1.69-1.69C38.8,27.59,34.58,22.66,28.62,19.44Z"
      fill={fill}
    />
    <path
      className="secondary"
      d="M14.88,29.9a8.68,8.68,0,0,0-6.16-2.55h0A8.72,8.72,0,0,0,2.56,42.24a8.64,8.64,0,0,0,6.16,2.55h0a8.73,8.73,0,0,0,8.71-8.72A8.61,8.61,0,0,0,14.88,29.9Zm.85,6.18a7,7,0,1,1-7-7A7,7,0,0,1,15.73,36.08Z"
      fill={secondaryFill}
    />
    <circle className="secondary" cx="8.72" cy="36.07" r="5.02" fill={secondaryFill} />
  </svg>
);
